import {
  leadsBenchmarkDataRequestLoading,
  leadsBenchmarkDataRequestCancelled,
} from '../general/actions';

import { LeadsBenchmarkLeadsActionTypes } from './constants';

/**
 * @param {import('../reducer.defaultState').LeadsBenchmarkResponse} response
 * @returns {{type: string, result: import('../reducer.defaultState').LeadsBenchmarkResponse, currentLevel: import('../../../../../shared/modules/dealersInsights/redux/level/reducer.defaultState').DealerInsightsLevel, currentDealerId: string }}
 */
export const getLeadsBenchmarkDataSuccess = ({
  result,
  currentLevel,
  currentDealerId,
}) => ({
  type: LeadsBenchmarkLeadsActionTypes.GET_LEADS_DATA_SUCCESS,
  result,
  currentLevel,
  currentDealerId,
});

/**
 * @param {any} error
 * @returns {{type: string, error: any}}
 */
export const getLeadsBenchmarkDataError = error => ({
  type: LeadsBenchmarkLeadsActionTypes.GET_LEADS_DATA_ERROR,
  error,
});

export const leadsApiProgressActions = {
  apiLoading: () => leadsBenchmarkDataRequestLoading(),
  apiCancelled: () => leadsBenchmarkDataRequestCancelled(),
};
